'use client'

import { ButtonLink } from '@repo/shared/components'
import { Icon, Row, Skeleton, Typography } from '@repo/ui/components'
import { useParams } from 'next/navigation'
import { useGetProjectDetails } from '@repo/services'

export const BalanceProjectCTA = ({
  origin,
}: {
  origin: 'layout' | 'container'
}) => {
  const { id } = useParams()

  const { data: response, isLoading } = useGetProjectDetails(id as string)
  const projectData = response?.data.project || {}

  return (
    <Row
      className={`${origin === 'layout' ? 'sticky top-0' : ''}  justify-between h-fit gap-md p-xs bg-neutral-surface-light`}
    >
      <ButtonLink
        variant='transparent'
        color='neutral'
        size='md'
        href='/wallet'
        aria-label='Back to Wallet'
        startIcon={<Icon name='ArrowRightLine' size='md' className='mt-xs' />}
      />

      {isLoading ? (
        <Skeleton className='w-36 h-md' />
      ) : (
        <Typography size='md' weight='bold' className='flex-1'>
          {projectData?.displayName}
        </Typography>
      )}
    </Row>
  )
}
